module.exports = __webpack_public_path__ + "img/chrome_web_tools_lighthouse.8097fe7e.png";